import { AxiosRequestConfig } from "axios"
import { Inject } from "inversify-props"
import type { EmbalagemServiceAdapter } from "./adapter/EmbalagemServiceAdapter"
import { Embalagem } from "@/models/Embalagem"

export class SaveEmbalagemUseCase {
	@Inject('EmbalagemServiceAdapter')
	private embalagemService!: EmbalagemServiceAdapter

	criar = async (embalagem: Embalagem) => await this.embalagemService.criar(embalagem)

	editar = async (embalagem: Embalagem) => await this.embalagemService.editar(embalagem)
}